export default __webpack_public_path__ + "static/left-2a5a0ec00c2c1c92bf4468398945ca10.png";